import AuthenticationCallBack from "pages/Welcome/AuthenticationCallBack";
import DesktopLayout from "layouts/Desktop";
import BasicTrade from "pages/BasicTrade";
import Market from "pages/Market";
import MobileLayout from "layouts/Mobile";
import React from "react";
import Welcome from "pages/Welcome";
import ComingSoon from "components/ComingSoon";
import WalletPortfolio from "pages/Wallet/portfolio";
import AdvancedTrade from "pages/AdvancedTrade";
import TradeHistory from "pages/History/TradeHistory";
import Wallet from "pages/Wallet";
import Portfolio from "pages/Portfolio";
import PortfolioDetails from "pages/Portfolio/PortfolioDetails";
import BasketHistory from "pages/History/Basket";
import RequestHistory from "../pages/History/Request";
import Broker from "pages/Broker";

const isMobileView = window.innerWidth <= 600;

const routes = () => {
  return [
    {
      element: isMobileView ? <MobileLayout /> : <DesktopLayout />,
      order: 0,
      children: [
        { path: "/", element: <ComingSoon /> },

        { path: "/market", element: <Market /> },
        { path: "/broker/:brokerId", element: <Broker /> },

        { path: "/wallet/portfolio/:id", element: <WalletPortfolio /> },
        { path: "/wallet", element: <Wallet /> },
        { path: "/wallet/basket/:id/:portfolioId", element: <WalletPortfolio isBasket={true} /> },

        { path: "/portfolio", element: <Portfolio /> },
        { path: "/portfolio-details/:coinId/:portfolioId", element: <PortfolioDetails /> },

        
        { path: "/history/trade-history", element: <TradeHistory /> },
        { path: "/history/basket-history", element: <BasketHistory /> },
        { path: "/history/request-history", element: <RequestHistory /> },

        { path: "/trade/:source/:destination", element: <BasicTrade /> },
        {
          path: "/advanced-trade/:source/:destination",
          element: <AdvancedTrade />,
        },
      ],
    },

    {
      path: "*",
      element: <Welcome />,
      order: 0,
    },
    {
      path: "/authentication/callback",
      element: <AuthenticationCallBack />,
      order: 0,
    },
    // {
    //   path: "GeneralComponents",
    //   element: <GeneralComponents />,
    //   order: 0,
    // },
  ];
};

export default routes;
